import { useIntl } from '@capsicum/common';
import { CountrySelect, TextInput } from '@capsicum/common-web';
import { type AmlRequirementProps, useAmlPostalAddress } from '@capsicum/features/regulations/shared';
import { FormProvider } from 'react-hook-form';

import * as S from './AmlQuestionnaire.styled';

export const PostalAddress = ({ requirement }: AmlRequirementProps) => {
	const { $t } = useIntl();

	const { postalAddressForm } = useAmlPostalAddress(requirement.config.prefill);

	return (
		<S.Wrapper>
			<FormProvider {...postalAddressForm}>
				<S.Question>{$t('amlQuestionnaire.postalAddressStep.question')}</S.Question>
				<CountrySelect
					disabled={!requirement.config.allowChangeOfAddress}
					label={$t('global.country')}
					labelProp="name"
					name="countryCode"
					testID="aml-questionnaire-postal-address-country-input"
					withoutInitialValue
					withSearch
				/>
				<TextInput
					autoCapitalize="none"
					label={$t('global.addressBuildingNumber')}
					name="addressBuildingNumber"
					testID="aml-questionnaire-postal-address-building-number-input"
				/>
				<TextInput
					autoCapitalize="none"
					disabled={!requirement.config.allowChangeOfAddress}
					label={$t('global.addressStreet')}
					name="street"
					testID="aml-questionnaire-postal-address-street-input"
				/>
				<TextInput
					autoCapitalize="none"
					disabled={!requirement.config.allowChangeOfAddress}
					label={$t('global.addressCity')}
					name="city"
					testID="aml-questionnaire-postal-address-city-input"
				/>
				<TextInput
					autoCapitalize="none"
					label={$t('global.addressMunicipalityOptional')}
					name="addressMunicipality"
					testID="aml-questionnaire-postal-address-municipality-input"
				/>
				<TextInput
					autoCapitalize="none"
					label={$t('global.addressProvinceOptional')}
					name="region"
					testID="aml-questionnaire-postal-address-province-input"
				/>
				<TextInput
					autoCapitalize="none"
					disabled={!requirement.config.allowChangeOfAddress}
					label={$t('global.addressPostcode')}
					name="zipCode"
					testID="aml-questionnaire-postal-address-postcode-input"
				/>
			</FormProvider>
		</S.Wrapper>
	);
};
